import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "./utils/appLanguage";
import "./index.css";
import App from "./App";
import "./assets/css/Style.css";

const basename = (process.env.PUBLIC_URL || '/').replace(/\/$/, '') || '/';

const router = createBrowserRouter(
    [
        {
            path: "/*",
            element: <App />,
        },
    ],
    { basename }
);

ReactDOM.createRoot(document.getElementById("root")).render(
    <React.StrictMode>
        <RouterProvider router={router} />
    </React.StrictMode>
);

// Register PWA service worker (production only)
if (typeof window !== 'undefined' && 'serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
    window.addEventListener('load', () => {
        let hasRefreshedForNewSw = false;
        const forceActivateWaitingWorker = (reg) => {
            if (reg?.waiting) {
                reg.waiting.postMessage({ type: 'SKIP_WAITING' });
            }
        };

        navigator.serviceWorker.register(`${basename}/service-worker.js`, { scope: basename || '/' })
            .then((reg) => {
                if (reg.installing) console.log('YesMLS Pro: SW installing');

                // If a newer worker is already waiting, activate it immediately.
                forceActivateWaitingWorker(reg);

                // Detect newly downloaded workers and activate them right away.
                reg.addEventListener('updatefound', () => {
                    const installingWorker = reg.installing;
                    if (!installingWorker) return;
                    installingWorker.addEventListener('statechange', () => {
                        if (installingWorker.state === 'installed' && navigator.serviceWorker.controller) {
                            forceActivateWaitingWorker(reg);
                        }
                    });
                });

                // Periodically check for updates while app is open.
                setInterval(() => {
                    reg.update().catch(() => { /* ignore transient update failures */ });
                }, 60 * 60 * 1000);
            })
            .catch((err) => console.warn('YesMLS Pro: SW registration failed', err));

        // Reload once when the new SW takes control so latest assets are used.
        navigator.serviceWorker.addEventListener('controllerchange', () => {
            if (hasRefreshedForNewSw) return;
            hasRefreshedForNewSw = true;
            window.location.reload();
        });
    });
}

